<div *ngIf="userAddress">
    <app-page-title [title]="'Edit Address'"></app-page-title>
    <div class="row">
        <div
            class="col-md-12"
            *ngIf="userAddress"
        >
            <div class="checkbox">
                <input
                    type="checkbox"
                    [(ngModel)]="userAddress.areShippingBillingAddressSame"
                    name="areShippingBillingAddressSame"
                />
                Same shipping and billing address
            </div>
            <br>
        </div>
    </div>

    <div
        class="row"
        *ngIf="countries"
    >
        <div class="col-md-6">
            <app-address-form
                [submitted]="submitted"
                [address]="userAddress.shippingAddress"
                [heading]="(userAddress.areShippingBillingAddressSame) ? 'Shipping/Billing Address' : 'Shipping Address'"
                [countries]="countries"
                [isFullNameDisabled]="true"
                (formValueChanged)="shippingFormValueChanged($event)"
            ></app-address-form>
        </div>
        <div class="col-md-6">
            <app-address-form
                *ngIf="!userAddress.areShippingBillingAddressSame"
                [submitted]="submitted"
                [address]="userAddress.billingAddress"
                [heading]="(userAddress.areShippingBillingAddressSame) ? 'Shipping/Billing Address' : 'Billing Address'"
                [countries]="countries"
                [isFullNameDisabled]="true"
                (formValueChanged)="billingFormValueChanged($event)"
            ></app-address-form>
        </div>
        <div class="col-md-12">
            <div class="form-group">
                <button
                    type="button"
                    class="btn btn-primary"
                    (click)="onSubmit()"
                >Save</button>
            </div>
        </div>
    </div>

</div>
